import { API_URL } from "../../config"
import { getToken } from "../../util/validation";

const token = JSON.parse(getToken);

export async function getAllAximaDomains() {
    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email
        }

        const response = await fetch(API_URL + 'axima/get_all_axima_domain/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {

            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }

}

export async function getAllAximaProducts(){
    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email
        }

        const response = await fetch(API_URL + 'axima/get_all_axima_products/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {

            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function AddAximaDomain(formData){
    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'formData': formData
        }

        const response = await fetch(API_URL + 'axima/add_axima_domain/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {

            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }   
}

export async function getAximaDomainDetail(subscription_id){
    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'subscription_id': subscription_id
        }

        const response = await fetch(API_URL + 'axima/get_axima_domain_details/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {

            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }   
}

export async function getAximaSubscriptionDetail(subscription_id){
    try {

        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'subscription_id': subscription_id
        }

        const response = await fetch(API_URL + 'axima/get_axima_subscription_details/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {

            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }   
}

export async function updateAximaDomain(formData, subscription_id, role, renewal_date){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
            'formData': formData,
            'subscription_id': subscription_id,
            'role': role,
            'renewal_date': renewal_date
        }

        const response = await fetch(API_URL + 'axima/update_axima_domain/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {

            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function getAllExisitingAximaDomains(){
    try {
        const email = localStorage.getItem('user')
        var data = {
            'email': email,
        }

        const response = await fetch(API_URL + 'axima/get_existing_axima_domain/', {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": token.login_token
            },
            body: JSON.stringify(data),
        });

        if (response.status === 200) {

            return response.json()
        }
        else {
            return false
        }
    } catch (error) {
        return false
    }
}

export async function addAximaLicense(seats, subscription){
    try {
        
            const email = localStorage.getItem('user')
            var data = {
                'subscription': subscription,
                'seats' : seats,
                'email': email
            }
    
            const response = await fetch(API_URL + 'axima/add_axima_license/', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token.login_token
                },
                body: JSON.stringify(data),
            });
    
            return response.status
    
        } catch (error) {
            return false
        }
}